<script setup lang="ts">
import AuthLayout from '@/layouts/auth/AuthSplitLayout.vue';

defineProps<{
    title?: string;
    description?: string;
    panelEyebrow?: string;
    panelHeadline?: string;
    panelSub?: string;
    panelStats?: { value: string; label: string }[];
    panelSteps?: { label: string; active: boolean }[];
    panelCard?: { title: string; body: string };
}>();
</script>

<template>
    <AuthLayout
        :title="title"
        :description="description"
        :panel-eyebrow="panelEyebrow"
        :panel-headline="panelHeadline"
        :panel-sub="panelSub"
        :panel-stats="panelStats"
        :panel-steps="panelSteps"
        :panel-card="panelCard"
    >
        <slot />
    </AuthLayout>
</template>
